// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__12o2K","active":"Navigation_active__1Sofg"};